import { render, staticRenderFns } from "./DGAnagrafiche.vue?vue&type=template&id=fd583602&scoped=true&"
import script from "./DGAnagrafiche.vue?vue&type=script&lang=js&"
export * from "./DGAnagrafiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd583602",
  null
  
)

export default component.exports